import { Form, Formik } from "formik";
import { useCallback } from "react";

import { PatientGuarantor } from "pwapi";

import {
  updatePatientGuarantor,
  createPatientGuarantor,
} from "shared/actions/admin/adminPatientActions";

import { useAppDispatch } from "app/hooks";
import { CaseState } from "app/reducers/admin/reducers/caseReducer";
import PatientGuarantorForm, {
  checkGuarantorAddress,
} from "ui/CaseForms/PatientGuarantorForm";

const CasePatientGuarantorForm = ({
  caseDetail,
  guarantor,
  patient_id,
}: {
  caseDetail?: CaseState;
  guarantor?: PatientGuarantor;
  patient_id?: number;
}) => {
  const dispatch = useAppDispatch();

  const blankGuarantor: PatientGuarantor = {
    first_name: "",
    last_name: "",
    middle_initial: "",
    ssn: "",
    date_of_birth: "",
    sex: undefined,

    address: {
      street: "",
      street2: "",
      city: "",
      state: "",
      zipcode: "",
      phone1: "",
      phone2: "",
    },
  };

  const initialValues = {
    ...blankGuarantor,
    ...guarantor,
    address: {
      ...blankGuarantor.address,
      ...guarantor?.address,
    } as PatientGuarantor["address"],
  };

  const onHandleSubmit = useCallback(
    (values) => {
      const address = checkGuarantorAddress({
        ...values.address,
      });
      guarantor?.id
        ? dispatch(
            updatePatientGuarantor({
              ...values,
              id: guarantor?.id,
              address: address && { ...address, id: guarantor.address?.id },
              date_of_birth: values.date_of_birth || null,
            })
          )
        : patient_id &&
          dispatch(
            createPatientGuarantor({
              patient_id: patient_id,
              ...values,
              address,
              date_of_birth: values.date_of_birth || null,
            })
          );
    },
    [patient_id, guarantor]
  );

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={onHandleSubmit}
    >
      {({ values, dirty, setValues }) => {
        return (
          <Form autoComplete="off">
            <PatientGuarantorForm
              values={values}
              billingType={caseDetail?.billing_type}
              displaySubmit
              dirty={dirty}
              onHandleChangeRelationship={(value: string) => {
                setValues({
                  ...blankGuarantor,
                  relationship_to_patient: value,
                  address: blankGuarantor.address,
                });
              }}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default CasePatientGuarantorForm;
